import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function StorySection() {
  return <section className="bg-navy-900 py-14 md:py-20 relative text-cream-50" data-id="element-303">
      <div className="container mx-auto px-4" data-id="element-304">
        <div className="max-w-[720px] mx-auto" data-id="element-305">
          <div className="flex items-center justify-center gap-3 mb-10" data-id="element-306">
            <div className="w-12 h-px bg-gold-500/30" data-id="element-307" />
            <div className="w-1.5 h-1.5 rotate-45 bg-gold-500/50" data-id="element-308" />
            <div className="w-12 h-px bg-gold-500/30" data-id="element-309" />
          </div>
          <FadeIn data-id="element-310">
            <div className="prose prose-lg md:prose-xl mx-auto" data-id="element-311">
              <p className="mb-6 leading-relaxed text-cream-100/90" data-id="element-312">
                <span className="font-heading font-bold text-2xl text-white" data-id="element-313">
                  Son las 3:14 AM.
                </span>{' '}
                Estás de pie frente al inodoro, en la oscuridad, esperando un
                flujo que apenas llega. Sientes esa presión punzante en el bajo
                vientre que no te deja en paz.
              </p>
              <p className="mb-6 leading-relaxed text-cream-100/90" data-id="element-314">
                Vuelves a la cama intentando no despertar a tu esposa, pero el
                sueño se ha esfumado. Mañana estarás irritable, agotado y sin
                energía.
              </p>
              <p className="mb-6 leading-relaxed text-cream-100/90" data-id="element-315">
                Sabes que esto no es solo "cosa de la edad". Es una prisión.
              </p>
              <p className="text-xl md:text-2xl font-heading font-bold text-white mt-8 border-l-4 border-gold-500 pl-6 py-2" data-id="element-316">
                Y esta noche, otra vez, te tocó pagar la condena.
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}